import { CrmSettingsState } from './settings.interfaces';

export const CrmSettingsInitialState: CrmSettingsState = {
  autovanceDeskRole: null,
  autovanceUserGuid: null,
  salesPlannerView: null,
  teamLead: null,
  rooftopId: null
};
